import Api from '@/services/Api'

export default {
  fetchInstagramId () {
    return Api().get('connect-with-instagram')
  }
}



// WEBPACK FOOTER //
// ./src/services/InflusightsService.js